module.exports = __webpack_public_path__ + "img/AI_note-B.b98de9a3.svg";